<template>
  <!-- /nft/soulfish/ — 《靈魂魚》400 版資料庫：EditionsDatabase 的靈魂魚實例（文案、篩選籤、活的連結在這裡；機制在 EditionsDatabase.vue）。
       資料層 src/data/soulfish-editions.json（無藏家名／錢包），縮圖 R2 側車清單 media-manifest-soulfish-editions.json。 -->
  <editions-database :data="data" :thumbs="thumbs" thumb-set="soulfish-editions" :copy="copy" :groups="GROUPS" :headline="HEADLINE" :color-keys="['fishColor', 'fishMinColor']" :live-for="liveFor" card-title="SoulFish" expandable glyph />
</template>

<script setup>
import { withSlash } from '@/runtime/site-path.mjs'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import EditionsDatabase from './EditionsDatabase.vue'
import data from '@/data/soulfish-editions.json'
import thumbs from '@/data/media-manifest-soulfish-editions.json'

const route = useRoute()
const zh = computed(() => route.path.startsWith('/zh/'))
const T = (a, b) => (zh.value ? a : b)
const local = p => withSlash((zh.value ? '/zh' : '') + p)

// 活的連結：2022 原版生成器自架在 soulfish.art.cheyuwu.com/fxhash/，400 版 hash 逐版對得上（現行威尼斯版拿掉了黑白／純白色板與星雲／深海背景，只有 282 版對得上，所以不指它）
const GENERATOR = 'https://soulfish.art.cheyuwu.com/fxhash/'
const liveFor = e => `${GENERATOR}?fxhash=${e.hash}`
// 篩選籤七組（色板／背景／體型／鱗片／和弦組／骨架／直鰭）；compact 卡亮五個主要性狀
const GROUPS = ['pallate', 'background', 'fishSize', 'scaleType', 'atmosphere', 'hasBone', 'verticalFin']
const HEADLINE = ['pallate', 'background', 'fishSize', 'scaleType', 'atmosphere']

const copy = computed(() => ({
  kicker: T('靈魂魚 · fxhash 2022 · 自記錄', 'SoulFish · fxhash 2022 · self-kept record'),
  h1: T('靈魂魚 400 版資料庫', 'SoulFish — the 400 editions'),
  lead: T(
    '二〇二二年六月三十日，《靈魂魚》在 fxhash 開放鑄造，原定一千版，後來收為四百版，二〇二三年一月十六日售罄。每一版由鏈上給定的一串 hash 長成：hash 先化為亂數，亂數依序決定十六個性狀，同一串亂數餵給噪聲與物理，於是同一個 hash 永遠長出同一隻魚。fxhash 的網站在二〇二六年停擺之後，這四百版的紀錄由我們自己保管：這一頁收著每一版的 hash 與鑄造日、十六個性狀在四百隻裡的稀有度、牠一輩子的和弦組，以及鑄造當下留下的擷圖；藏家的名字與錢包位址留在鏈上，不在這裡。',
    'SoulFish opened for minting on fxhash on 30 June 2022; the edition, first set at one thousand, was closed at four hundred and sold out on 16 January 2023. Each edition grows from a hash assigned on chain: the hash becomes a stream of random numbers, the numbers decide sixteen traits in order, the same stream feeds the noise and the physics, and so the same hash always grows the same fish. Since the fxhash site went dark in 2026 the record of these four hundred is kept here, by us — every hash and mint date, the sixteen traits with their rarity among the four hundred, the chord set each fish keeps for life, and the capture taken at mint. Collectors’ names and wallet addresses stay on chain, not on this page.'),
  facts: [
    [T('平台', 'Platform'), 'fxhash · Tezos'], ['Token', '#' + data.token], [T('版數', 'Editions'), String(data.supply)],
    [T('鑄造', 'Minted'), `${data.mintedFrom} → ${data.soldOut}`], [T('性狀', 'Traits'), T('十六個', 'sixteen')], [T('和弦組', 'Chord sets'), T('八組', 'eight')],
    [T('生成器', 'Generator'), 'p5.js 1.4 · Tone.js'],
  ],
  provenance: T(
    '資料來源：二〇二六年九月十九日自 fxhash 的公開 API 與 IPFS 取回的四百筆鏈上紀錄與四百張鑄造擷圖，逐版核對 hash 與版號守恆，原始檔另存於自家檔案庫；稀有度是該性狀值在四百隻裡的張數比。',
    'Sources: the four hundred on-chain records and four hundred mint captures retrieved from the fxhash public API and IPFS on 19 September 2026, checked edition by edition for hash and number, with the raw files kept in our own archive; rarity is the share of the four hundred that carry the same value.'),
  links: [
    { to: local('/work/soulfish/'), label: T('回到《靈魂魚》作品頁', 'Back to the SoulFish work page') },
    { href: GENERATOR, label: T('2022 年原版生成器（本站自架）', 'The 2022 generator, self-hosted') },
    { href: 'https://soulfish.art.cheyuwu.com/', label: T('現行展場版', 'The current exhibition build') },
  ],
  searchHint: T('#283 或 ooDDmJ…', '#283 or ooDDmJ…'),
  unit: T('隻', ''),
}))
</script>
